<template>
  <div>
    <b-form @submit="onSubmit" @reset="onReset">

    <div class="clearfix pt-3">
        <b-button v-if="editMode" type="reset" :pressed.sync="editMode"  size="sm" variant="danger" class="float-right ml-3">
        abbrechen
        </b-button>
        <b-button v-if="!editMode" :pressed.sync="editMode" variant="default" class="profile_button float-right">
          <span class="bi-pencil" aria-hidden="true"></span>
        </b-button>
        <b-button type="submit" v-if="editMode" size="sm" variant="primary" class="float-right"
          aria-label="Left Align">speichern
        </b-button>
    </div>
    <div v-if="!editMode" v-for="(cat, idx) in groupedSendungen()" :key="idx">
    <h3 class="underline">{{cat.format.name }}</h3>
    <b-list-group v-for="(sendung, fidx) in cat.items" :key="fidx">
       <b-list-group-item :class="plistClass(sendung.priority)">
       {{sendung.sendung.name}}
       <b-button variant="default" class="float-right float-top" @click="removeSendung(`${sendung.sendungid}`)">
          <span class="bi-x-circle" aria-hidden="true"></span>
      </b-button>
        </b-list-group-item>
    </b-list-group>
    </div>

    <div v-if="!editMode" class="pt-3">
    <b-alert :show="Object.keys(groupedSendungen()).length===0">keine Einträge</b-alert>
    </div>

   <div v-if="editMode">
    <div class="row">
    <div class="col-xs-12 col-lg-8">
    <div class="clearfix">
     <label class="d-block">Reihenfolge
     <div class="float-right">
        <b-button  :pressed.sync="collapseSort" variant="outline-secondary" size="sm">
             <i v-if="collapseSort" class="bi bi-chevron-down"></i>
             <i v-if="!collapseSort" class="bi bi-chevron-up"></i>
        </b-button>
      </div>
     </label>
     </div>
      <b-collapse v-model="collapseSort">
     <b-card no-body>
    <draggable
       tag="ul"
        :list="formats"
        class="list-group"
        ghost-class="ghost"
      >
     <transition-group type="transition" name="flip-list">
    <li
          class="list-group-item clickable"
          v-for="element in formats"
          :key="element.weight"
        >
          <i  v-b-tooltip.hover title="Ziehen um zu sortieren" class="bi bi-grip-vertical"></i>
          {{ element.name }}
        </li>
       </transition-group>
      </draggable>

      </b-card>
      </b-collapse>
    </div>
    </div>

   <div class="row">
       <div class="col-lg-4 col-sm-6 col-xs-12" >
      <b-form-group
          id="input-group-13"
          label="Kategorie"
          label-for="input-13">
            <b-form-select
              id="input-13"
              v-model="kategorie"
              @change="switchKategorie"
              required>
              <option v-for="(sk, id) in categories" v-bind:key="id" :value="id">{{sk.name}}</option>
            </b-form-select>
      </b-form-group>
    </div>
    <div class="col-lg-4 col-sm-6 col-xs-12">
      <b-form-group
          id="input-group-14"
          label="Sender"
          label-for="input-14">
            <b-form-select
              id="input-14"
              @change="switchSender"
              v-model="selectedSenderId"
              >
              <option v-for="(sender, id) in senderListe" v-bind:key="id" :value="sender.id">{{sender.name}}</option>
            </b-form-select>
      </b-form-group>
    </div>
   </div>
   <div class="row">
     <div class="col-lg-8 col-xs-12">
     <b-alert :show="sendungen.length===0">keine Sendungen vorhanden</b-alert>
        <b-list-group v-for="(sendung, idx) in sendungen" :key="idx">
             <b-list-group-item :class="listClass(sendung.id)">
             <b-form-checkbox v-model="checked[sendung.id]" name="check-button">{{sendung.name}}</b-form-checkbox>
             <b-form-radio-group v-if="checked[sendung.id]" class="pt-3"
                  :id="radioGroupId(sendung.id)"
                  v-model="prioritySelected[sendung.id]"
                  :options="priorityOptions"
                  aria-describedby="Priorität für Profilanzeige"
                  :name="radioGroupName(sendung.id)"
                ></b-form-radio-group>
              </b-list-group-item>
          </b-list-group>
          <b-button class="mt-3" @click="requestLogo()" variant="outline-primary">Fehlende Logos anfordern</b-button>
      </div>
   </div>
   </div>
    </b-form>
  </div>
</template>

<script>
import api from '@/api/benutzer'
import workflowApi from '@/api/workflow'
import draggable from 'vuedraggable'
import utils from '@/utilities'

export default {
  name: 'ProfilSendungen',
  props: ['user', 'profil'],
  components: {
    draggable
  },
  watch: {
    user: function (newUser, oldUser) {
      this.updateItems(newUser)
    }
  },
  mounted () {
    this.updateItems(this.$props.user)
  },
  methods: {
    async requestLogo () {
      let message = prompt('Welche Logos wollen Sie anfordern?')
      if (message) {
        let result = await workflowApi.simpleAction(0, message)
        let error = result['errorMessage'] ? result['errorMessage'] : (result['errors'] ? result['errors']['errorMessage'] : null)

        if (result && !error) {
          utils.makeToast(this, 'Nachricht verschickt!', 'success')
        } else {
          utils.makeToast(this, error, 'danger')
        }
      }
    },
    formatsSort (c1, c2) {
      let w1 = c1.weight
      let w2 = c2.weight
      if (this.user.sendungenSortierung) {
        if (this.user.sendungenSortierung[c1.id] != null) {
          w1 = this.user.sendungenSortierung[c1.id]
        }
        if (this.user.sendungenSortierung[c2.id] != null) {
          w2 = this.user.sendungenSortierung[c2.id]
        }
      }
      return w1 - w2
    },
    notPresent (sendungid) {
      for (let i = 0; i < this.user.sendungen.length; i++) {
        if (this.user.sendungen[i].id.sendungId === sendungid) {
          return false
        }
      }
      return true
    },
    async removeSendung (id) {
      if (confirm('Wollen Sie diesen Eintrag entfernen?')) {
        await api.deleteSendung(this.user.id, id)
        let user = await api.get(this.user.id)
        this.$bubble('userchanged', user)
      }
    },
    findSender (senderid) {
      for (let senderCat in this.$store.state.auth.baseData.sender) {
        for (let i = 0; i < this.$store.state.auth.baseData.sender[senderCat].length; i++) {
          if (this.$store.state.auth.baseData.sender[senderCat][i].id === senderid) {
            return {'category': this.$store.state.auth.baseData.senderCategories[senderCat], 'sender': this.$store.state.auth.baseData.sender[senderCat][i]}
          }
        }
      }
      return {}
    },
    findSendung (senderid) {
      for (let i = 0; i < this.$store.state.auth.baseData.sendungen.length; i++) {
        if (this.$store.state.auth.baseData.sendungen[i].id === senderid) {
          return this.$store.state.auth.baseData.sendungen[i]
        }
      }
      return {}
    },
    findFormat (formatId) {
      for (let i = 0; i < this.$store.state.auth.baseData.formats.length; i++) {
        if (this.$store.state.auth.baseData.formats[i].id === formatId) {
          return this.$store.state.auth.baseData.formats[i]
        }
      }
      return {}
    },
    compareLogo (s1, s2) {
      if (s1.sendung.logoname && s2.sendung.logoname) {
        return s1.sendung.logoname.localeCompare(s2.sendung.logoname)
      }
      return s1.sendung.weight - s2.sendung.weight
    },
    groupedSendungen () {
      // die sendungen nach format gruppieren
      let sendungen = {}
      if (this.user && this.user.sendungen) {
        for (let i = 0; i < this.user.sendungen.length; i++) {
          const sendung = this.findSendung(this.user.sendungen[i].id.sendungId)
          const sender = this.findSender(sendung.senderId)
          const format = this.findFormat(sendung.formatId)
          let fgroup = sendungen[format.name]
          if (!fgroup) {
            fgroup = {'format': format, 'items': []}
          }
          fgroup['format'] = format
          fgroup['items'].push({'sender': sender.sender, 'sendung': sendung, 'sendungid': sendung.id, 'priority': this.user.sendungen[i].prioritaet})
          fgroup['items'] = fgroup['items'].sort((s1, s2) => (s2.priority - s1.priority !== 0 ? s2.priority - s1.priority : this.compareLogo(s1, s2)))
          sendungen[format.name] = fgroup
        }
        let tmp = []
        // eslint-disable-next-line
        for (const [key, value] of Object.entries(sendungen)) {
          tmp.push(value)
        }
        tmp = tmp.sort((s1, s2) => { return this.formatsSort(s1.format, s2.format) })
        return tmp
      }
      return sendungen
    },
    plistClass (prio) {
      return 'prio' + prio
    },
    listClass (index) {
      return 'prio' + this.prioritySelected[index]
    },
    radioGroupName (index) {
      return 'radio-options-' + index
    },
    radioGroupId (index) {
      return 'radio-group-' + index
    },
    updateItems (user) {
      this.switchKategorie()
      this.formats = Object.values(this.$store.state.auth.baseData.formats).sort(this.formatsSort)
      if (this.user.sendungen) {
        for (let i = 0; i < this.user.sendungen.length; i++) {
          this.checked[this.user.sendungen[i].id.sendungId] = true
        }
      }
    },
    countSendungen (senderId) {
      let sendungen = this.$store.state.auth.baseData.sendungen.filter(sendung => sendung.senderId === senderId, this)
      return sendungen.length
    },
    switchSender () {
      // eslint-disable-next-line
      this.sendungen = this.$store.state.auth.baseData.sendungen.filter(sendung => sendung.senderId == this.selectedSenderId, this)
    },
    switchKategorie () {
      if (this.kategorie) {
        this.senderListe = this.$store.state.auth.baseData.sender[this.kategorie].filter(sender => this.countSendungen(sender.id) > 0, this)
      } else {
        this.senderListe = []
      }
    },
    async onSubmit (event) {
      event.preventDefault()
      event.stopPropagation()
      if (!this.editMode) {
        this.editMode = !this.editMode
        return
      }
      let sendungen = []
      const sendungListe = this.$store.state.auth.baseData.sendungen
      for (const s of sendungListe) {
        if (this.checked[s.id]) {
          let sendung = {}
          sendung.id = s.id * 1
          sendung.priority = this.prioritySelected[s.id]
          sendungen.push(sendung)
        }
      }
      let sortorder = []
      for (let i = 0; i < this.formats.length; i++) {
        let order = {}
        order.id = this.formats[i].id
        order.order = i
        sortorder.push(order)
      }

      let result = await api.updateSendung(this.user.id, {'sendungen': sendungen, 'sortorder': sortorder})
      if (result && !result['errorMessage']) {
        this.editMode = false
        this.checked = []
        let user = await api.get(this.user.id)
        this.$bubble('userchanged', user)
      } else {
        utils.makeToast(this, result['errorMessage'], 'danger')
      }
    },
    onReset (event) {
      event.preventDefault()
      // Reset our form values
      this.form = []
      // Trick to reset/clear native browser form validation state
      this.show = false
      this.$nextTick(() => {
        this.show = true
      })
    }
  },
  data () {
    return {
      kategorie: 1,
      sendungen: [],
      formats: Object.values(this.$store.state.auth.baseData.formats),
      checked: [],
      collapseSort: false,
      selectedSenderId: null,
      prioritySelected: [],
      categories: this.$store.state.auth.baseData.senderCategoriesWithSendung,
      senderListe: [],
      priorityOptions: [
        {text: 'hohe Priorität', value: 3},
        {text: 'mittlere Priorität', value: 2},
        {text: 'niedrige Priorität', value: 1}
      ],
      editMode: false
    }
  }
}
</script>

<style scoped>
.prio1 {
  border-left-color: #777;
  border-left-width: 3px;
}
.prio2 {
  border-left-color: green;
  border-left-width: 3px;
}
.prio3 {
  border-left-color: orange;
  border-left-width: 3px;
}
</style>



// WEBPACK FOOTER //
// src/main/vue/components/profil/Sendungen.vue